module.exports = __webpack_public_path__ + "img/empty-mailbox.61beb881.svg";